var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideosStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4.5V13.5C14.5 13.7652 14.3946 14.0196 14.2071 14.2071C14.0196 14.3946 13.7652 14.5 13.5 14.5H4.5M11 1.5H2.5C1.94771 1.5 1.5 1.94771 1.5 2.5V11C1.5 11.5523 1.94771 12 2.5 12H11C11.5523 12 12 11.5523 12 11V2.5C12 1.94771 11.5523 1.5 11 1.5ZM4.75004 8.64009V4.86009C4.74928 4.79555 4.76589 4.73199 4.79812 4.67607C4.83035 4.62015 4.87702 4.57393 4.93325 4.54223C4.98948 4.51054 5.05319 4.49455 5.11772 4.49593C5.18225 4.49731 5.24522 4.51602 5.30004 4.55009L8.57004 6.44009C8.62395 6.47191 8.66862 6.51725 8.69965 6.57161C8.73069 6.62597 8.74701 6.68749 8.74701 6.75009C8.74701 6.81269 8.73069 6.8742 8.69965 6.92857C8.66862 6.98293 8.62395 7.02826 8.57004 7.06009L5.30004 9.00009C5.24156 9.03765 5.17344 9.05749 5.10393 9.05719C5.03442 9.05689 4.96649 9.03647 4.90833 8.9984C4.85017 8.96033 4.80427 8.90624 4.77618 8.84266C4.74809 8.77907 4.73902 8.70872 4.75004 8.64009Z",
    stroke: "black",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideosStack);
export default __webpack_public_path__ + "static/media/videos-stack.fe478163e62e9f1bf8503aace308a06c.svg";
export { ForwardRef as ReactComponent };